<!--
 * @Descripttion:任务管理页面
 * @version: 0.0.1
 * @Author: haihua.xu
 * @Date: 2020-03-26 18:37:28
 * @LastEditors: haihua.xu
 * @LastEditTime: 2020-04-01 19:37:37
 -->
 <template>
  <basicContainer>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="refresh"
      @cell-click="cellClick"
      :before-open="beforeOpen"
    >
      <!-- 状态栏目扩展  -->
      <template v-slot:trigger_status="{row,label,dic,$index}">
        <el-tag v-if="label === '运行'" type="success">{{label}}</el-tag>
        <el-tag v-else type="info">{{label}}</el-tag>
      </template>
      <template slot-scope="{row,label,dic,$index}" slot="menu">
        <!-- 操作列-状态改变 -->
        <el-button
          v-if="row.trigger_status===0"
          type="text"
          size="small"
          @click="handleChangeStatus(row)"
          icon="el-icon-check"
        >启动</el-button>
        <el-button
          v-else
          type="text"
          @click="handleChangeStatus(row)"
          icon="el-icon-close"
          size="small"
        >停止</el-button>
        <!-- 操作列-执行按钮 -->
        <el-button type="text" @click="doOperation(row)" size="small">执行</el-button>
        <!-- 操作列-日志按钮 -->

        <el-button type="text" @click="toOperationLog(row)" size="small">
          <!-- 到调度日志页面 -->
          日志
        </el-button>
        <!-- 操作列-GLUE IDE按钮 -->
        <el-button
          v-if="row.glue_type!=='BEAN'"
          type="text"
          @click="toGlueIde(row)"
          size="small"
        >GLUE IDE</el-button>
      </template>
    </avue-crud>
    <!-- 执行弹窗 -->
    <el-dialog
      title="执行"
      :visible.sync="operationDialog.show"
      width="40%"
      top="10vh"
      :append-to-body="true"
      show-close="false"
    >
      <el-form ref="operationDialogForm" :model="operationDialog.form" label-width="80px">
        <el-form-item label="任务参数">
          <el-input
            v-model="operationDialog.form.executorParam"
            type="textarea"
            placeholder="请输入任务参数"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sureOperate('operationDialogForm')">保存</el-button>
          <el-button type="info" @click="closeOperDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 选择高级时间配置的弹窗 -->
    <el-dialog
      title="高级时间配置"
      :visible.sync="timeDialogVisible"
      width="55%"
      height="40%"
      padding="20"
      :append-to-body="true"
      :before-close="handleClosetime"
    >
      <div class="app">
        <cron v-model="cronExpressionStr"></cron>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="timeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdvancedTimeConfig">确 定</el-button>
      </span>
    </el-dialog>
  </basicContainer>
</template>

<script>
// 引入配置时间模块
import cron from '../../taskSchedulingManage/public/cron.vue'

export default {

  data () {
    return {
      // 高级时间配置参数
      cronExpressionStr: '',

      // 时间配置cron表达式二级弹窗的显示与关闭属性
      timeDialogVisible: false,
      // 执行操作的弹窗配置
      operationDialog: {
        show: false,
        form: {
          executorParam: '',
          executor_fail_retry_count: null
        }
      },

      form: {

      },
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      // 加载检测表下拉数据的参数
      schemaId: -1,
      tableName: '',
      option: {
        title: '任务管理',
        dialogWidth: 1000,
        dialogHeight: 500,
        height: 500,
        align: 'center',
        index: false,
        tip: true,
        stripe: true,
        menuWidth: 320,
        border: true,
        viewBtn: false,
        delBtn: true,
        editBtn: true,
        selection: false,
        column: [
          {
            label: '任务ID',
            prop: 'id',
            width: 100,
            overHidden: true,
            labelWidth: 100,
            span: 12,
            addDisplay: false,
            editDisplay: false
          },
          {
            label: '执行器',
            prop: 'job_group',
            hide: true,
            width: 100,
            overHidden: true,
            labelWidth: 100,
            span: 12,
            type: 'select',
            dicData: [],
            props: {
              label: 'title',
              value: 'id'
            },
            rules: [{
              required: true,
              message: '请选择执行器',
              trigger: 'blur'
            }],
            plcaholder: '请选择执行器',
            search: true
          },
          {
            label: '任务描述',
            prop: 'job_desc',
            labelWidth: 100,
            overHidden: true,
            span: 12,
            search: true,
            rule: [{
              required: true,
              message: '请输入任务描述',
              trigger: 'blur'
            }]
          },
          {
            label: '运行模式',
            prop: 'glue_type',
            width: 150,
            labelWidth: 100,
            overHidden: true,
            editDisabled: true,
            span: 12,
            type: 'select',
            dicData: [],
            change: (obj) => {
              if (obj.value && obj.value === 'BEAN') {
                this.option.column[6].addDisabled = false
                this.option.column[6].editDisabled = false
                this.option.column[6].rules =
                  [{                    required: true,
                    message: '请输入Jobhandler',
                    trigger: 'blur'                  }]
              } else if (obj.value) {
                this.option.column[6].addDisabled = true
                this.option.column[6].editDisabled = true
                this.option.column[6].rules = [{ required: false }]

              }
            }
          },
          {
            label: '路由策略',
            prop: 'executor_route_strategy',
            hide: true,
            width: 100,
            overHidden: true,
            labelWidth: 100,
            span: 12,
            type: 'select',
            dicData: [],
            rules: [{
              required: true,
              message: '请输入路由策略',
              trigger: 'blur'
            }]
          },
          {
            label: 'Cron',
            labelWidth: 100,
            prop: 'job_cron',
            placeholder: '请点击生成自定义的cron表达式',
            width: 250,
            span: 12,
            overHidden: true,
            rules: [{
              required: true,
              message: '必填',
              trigger: 'blur'
            }],
            focus: () => {
              this.timeDialogVisible = true
            },
            change: (obj) => {
              if (!obj.value) {
                this.option.column[4].rules = [{
                  required: true,
                  message: '请重新选择生成cron表达式',
                  trigger: 'blur'
                }]
              }
            }
          },
          {
            label: 'Jobhandler',
            prop: 'executor_handler',
            labelWidth: 100,
            hide: true,
            search: true,
            dicData: [],
            width: 100,
            overHidden: true,
            addDisabled: false,
            editDisabled: false,
            span: 12,
            rules: [{
              required: true,
              message: '请输入Jobhandler',
              trigger: 'blur'
            }]
          },
          {
            label: '阻塞处理策略',
            prop: 'executor_block_strategy',
            labelWidth: 100,
            hide: true,
            type: 'select',
            dicData: [],
            overHidden: true,
            span: 12
          },
          {
            label: '子任务ID',
            prop: 'child_jobid',
            labelWidth: 100,
            width: 100,
            type: 'select',
            props: {
              label: 'job_desc',
              value: 'id'
            },
            multiple: true,
            dicData: [],
            span: 12,
            hide: true
          },
          {
            label: '任务超过时间',
            prop: 'executor_timeout',
            labelWidth: 100,

            type: 'number',
            tip: '以秒为单位,大于零时生效',
            span: 12,
            row: true,
            minRows: 0,
            hide: true
          },
          {
            label: '负责人',
            prop: 'author',
            labelWidth: 100,
            overHidden: true,
            search: true,
            span: 12,

            rules: [{
              required: true,
              message: '请输入负责人',
              trigger: 'blur'
            }]
          },
          {
            label: '失败重试次数',
            prop: 'executor_fail_retry_count',
            labelWidth: 100,
            span: 12,
            type: 'number',
            tip: '大于零时生效',
            row: true,
            minRows: 0,
            hide: true
          },

          {
            label: '报警邮件',
            prop: 'alarm_email',
            labelWidth: 100,
            span: 12,
            hide: true,
            tip: '请输入邮件地址，多个地址时请用“,”隔开'

          },
          {
            label: '状态',
            prop: 'trigger_status',
            labelWidth: 80,
            addDisplay: false,
            editDisplay: false,
            overHidden: true,
            dicData: [
              {
                label: '运行',
                value: 1
              },
              {
                label: '停止',
                value: 0
              }
            ],
            span: 12,
            type: 'select',
            slot: true,
            search: true
          },
          {
            label: '任务参数',
            prop: 'executor_param',
            labelWidth: 100,
            span: 24,
            type: 'textarea',
            hide: true
          }
        ]
      },
      data: []
    }
  },

  mounted () {
    // 获取执行器数据
    this.getjobGroupListData()
    //获取路由策略数据
    this.getOthersListData('ExecutorRouteStrategyEnum')
    //获取运行模式数据
    this.getOthersListData('GlueTypeEnum')
    //获取阻塞处理策略数据
    this.getOthersListData('ExecutorBlockStrategyEnum')
    //获取子任务下拉数据
    this.getChildJobId()
  },
  watch: {

  },
  computed: {

  },

  components: {
    cron
  },
  methods: {

    // 时间选择框的关闭事件
    handleClosetime (done) {
      this.timeDialogVisible = false
    },
    // 高级时间选择成功
    saveAdvancedTimeConfig () {
      this.form.job_cron = this.cronExpressionStr
      if (this.form.job_cron) {
        this.option.column[4].rules = [{ required: false }]
      } else {
        this.option.truecolumn[4].rules = [{
          required: true,
          message: '请重新选择生成cron表达式',
          trigger: 'blur'        }
        ]
      }
      this.timeDialogVisible = false
    },
    // 执行弹窗-保存
    sureOperate (row) {
      debugger
      let executorParam = this.operationDialog.form.executorParam
      if (!executorParam && typeof (executorParam) !== 'undefined') {

      } else {
        executorParam = ''
      }

      this.$http.put(
        `/xxl/job-info/trigger?id=${this.operationDialog.form.id}&executorParam=${executorParam}`,
        { headers: { 'content-type': 'application/json' } }
      ).then(response => {
        this.$message.success('执行成功') && this.closeOperDialog()
        this.onLoad()
      }).catch(error => {
        this.$message.error(error.msg) && this.closeOperDialog()
      })
    },
    cellClick: function (row, column, cell, event) {
      this.$refs.crud.toggleRowSelection(row)
    },
    refresh: function () {
      this.onLoad()
    },
    searchReset () {
      this.query = {}
      this.onLoad()
    },
    searchChange (params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.query = params
      this.onLoad()
    },

    currentChange (currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize
    },
    rowSave (row, loading, done) {
      if (Object.prototype.toString.call(row.child_jobid) === '[object Array]') {
        // 将子任务数据的id数组转为id字符串,与后台保持一致
        row.child_jobid = row.child_jobid.join(',')
      }
      this.$http.post('/xxl/job-info', JSON.stringify(row),
      ).then(response => {
        this.$message.success('添加成功') && loading()
        this.onLoad()
      }).catch(error => {
        this.$message.error(error.msg) && done()
      })
    },
    // 关闭执行弹窗
    closeOperDialog () {
      this.operationDialog.form = {}
      this.operationDialog.show = false
    },
    // 跳转到GLUE IDE页面
    toGlueIde (row) {
      // 后期完善
      // this.$router.push({ path: `/jobcode/?jobId=${row.id}`})
    },
    // 跳转到调度日志页面
    toOperationLog (row) {
      this.$router.push({ path: `/operationLog/?jobId=${row.id}` })
    },
    // 执行
    doOperation (row) {
      this.operationDialog.form = { id: row.id }
      this.operationDialog.show = true
    },
    // 改变状态
    handleChangeStatus (row) {
      // 停止路径
      var changeUrl = '/xxl/job-info/stop'
      if (row.trigger_status === 0) {
        // 启动路径
        changeUrl = '/xxl/job-info/start'
      }
      this.$http.put(`${changeUrl}?id=${row.id}`, { headers: { 'content-type': 'application/json' } }
      ).then(response => {
        this.$message.success('状态修改成功')
        this.onLoad()
      }).catch(error => {
        this.$message.error(error.msg)
      })
      this.onLoad()
    },
    rowUpdate (row, index, loading, done) {
      if (Object.prototype.toString.call(row.child_jobid) === '[object Array]') {
        // 将子任务数据的id数组转为id字符串,与后台保持一致
        row.child_jobid = row.child_jobid.join(',')
      }
      this.$http.put('/xxl/job-info', JSON.stringify(row), { headers: { 'content-type': 'application/json' } }
      ).then(response => {
        this.$message.success('编辑成功') && loading()
        this.onLoad()
      }).catch(error => {
        this.$message.error(error.msg) && done()
      })
    },
    rowDel (row, index) {
      this.deleteRows([row], () => {
        this.data.splice(index, 1)
      })
    },

    deleteRows: function (deleteList, callback) {
      this.$confirm('确定删除所选记录?是：删除；否：返回列表', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$http.delete('/xxl/job-info', { params: { idList: deleteList.map(item => item.id) } }).then(
          response => {
            this.$message.success('删除成功') && typeof callback === 'function' && callback()
          }).catch(error => {
            this.$message.error(error.msg)
          })
      }).catch(e => { })
    },
    // 打开弹框之前
    beforeOpen (done, type) {
      // console.log(this.form.job_group,typeof this.form.job_group)
      if (['edit'].includes(type)) {
        if (this.form.child_jobid) {
          // 存在值时
          if (Object.prototype.toString.call(this.form.child_jobid) === '[object String]') {
            var childJobidStr = this.form.child_jobid
            setTimeout(() => {
              this.form.child_jobid = childJobidStr.split(',').map(Number)
            }, 10)
          }
        }
        // 空值时
        this.form.child_jobid = this.form.child_jobid ? this.form.child_jobid : null
        this.form.alarm_email = this.form.alarm_email ? this.form.alarm_email : null
        this.form.executor_fail_retry_count = (this.form.executor_fail_retry_count === 0) ? null : this.form.executor_fail_retry_count
        this.form.executor_timeout = this.form.executor_timeout ? this.form.executor_timeout : null

      }
      done()
    },
    // 获取执行器下拉数据
    getjobGroupListData () {
      this.$http.get('/xxl/job-group',
      ).then(
        response => {
          if (response.data) {
            console.log('+++', typeof response.data[0].id)
            this.option.column[1].dicData = response.data
          }
        }
      ).catch(
        error => {
          this.$message.error(error.msg)
        }
      )
    },
    // 获取子任务数据
    getChildJobId () {
      this.$http.get(`/xxl/job-info`)
        .then(res => {
          if (res.data) {
            this.option.column[8].dicData = res.data
          }
        })
    },
    // 获取路由策略数据
    getOthersListData (key) {
      this.$http.get(`/pub/dm-const/listByCataCode?cataCode=${key}`)
        .then(res => {
          if (res.data) {
            if (key === 'ExecutorRouteStrategyEnum') {
              this.option.column[4].dicData = res.data
            } else if (key === 'GlueTypeEnum') {
              this.option.column[3].dicData = res.data
            } else {
              this.option.column[7].dicData = res.data
            }
          }
        }).catch(error => {
          console.log(error.msg)
        })
    },
    onLoad (page = this.page, params = this.query) {
      this.loading = true
      params.pageNum = page.currentPage,
        params.pageSize = page.pageSize
      this.$http.get('/xxl/job-info/query', { params: params }
      ).then(
        response => {
          this.loading = false
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    }
  }
}
</script>
  <style lang='scss' scoped>
</style>



